export const ADMIN_ROUTE_NAMES = {
  ADMIN_ROOT: 'admin-root',
  ADMIN_EXPORT_LANDING_ROUTE_PREFIX: 'admin-export-landing-page-',
  ADMIN_EXPORT_CREATE_ROUTE_PREFIX: 'admin-export-create-',
  ADMIN_EXPORT_EDIT_ROUTE_PREFIX: 'admin-export-edit-',
  ADMIN_LIST_LANDING_ROUTE_PREFIX: 'admin-list-landing-page-',
  ADMIN_LIST_CREATE_ROUTE_PREFIX: 'admin-list-create-',
  ADMIN_LIST_EDIT_ROUTE_PREFIX: 'admin-list-edit-',
  ADMIN_ENTITIES_SETTINGS: 'admin-entities-settings',
  ADMIN_INTEGRATION_POINT_CARDS: 'admin-integration-point-cards',
  ADMIN_OUTBOUND_MESSAGES: 'admin-outbound-messages-landing',
} as const

export const ADMIN_ROUTE_PATHS = {
  ADMIN_AI_SUMMARIZE: '/assist/admin/ai/summarize',
  AUTOMATIC_RESOLUTION_NOTES: '/assist/admin/ai/automatic-resolution-notes',
  EXTERNAL_REFERENTIAL_CUSTOMER_MS: '/assist/admin/customer/external-referential',
  MAIL_STORAGE_SETTINGS: '/assist/admin/mail/storage-settings',
  IN_TRANSIT_MAIL_JOB_CONFIGURATION: '/assist/admin/mail/job-configuration',
  ENTITIES_SETTINGS: '/assist/admin/entities/settings',
  INTEGRATION_POINT_CARDS: '/assist/admin/integration-point-cards',
  OUTBOUND_MESSAGES: '/assist/admin/outbound-messages/list',
} as const
